module.exports = __webpack_public_path__ + "static/media/reference-slider-2.a713335a.jpg";